import { URLS } from '../../../constants';
import apiClient from '../../client';

const AuthorizedCodeGrid = {
  getAuthorizedGridApi: ({
    heading,
    roleId,
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
    isNotPaginated,
  }: {
    heading: string;
    roleId?: string;
    type: string;
    assignedTo: string;
    pagination: any;
    order: any;
    name: any;
    filterValue: any;
    isNotPaginated?: any;
  }) =>
    apiClient.post(URLS.authorizationCodeGrid, {
      data: {
        heading,
        roleId,
        isNotPaginated,
        type,
        pagination,
        filter: [
          {
            filterKey: 'name',
            filterValue: filterValue || '',
          },
        ],
        assignedTo,
        sorting: {
          order: (order && String(order).toUpperCase()) || 'DESC',
          fieldName: name || 'createdDate',
        },
      },
    }),
  changeBillingCodeStatus: ({
    authorizationCodeId,
    status,
  }: {
    authorizationCodeId: any;
    status: any;
  }) =>
    apiClient.post(URLS.changeBillingStatus, {
      data: { authorizationCodeId, status },
    }),
};

export default AuthorizedCodeGrid;
